import { render, staticRenderFns } from "./leifeng-groupbuy.vue?vue&type=template&id=2b5f346d&scoped=true&"
import script from "./leifeng-groupbuy.vue?vue&type=script&lang=js&"
export * from "./leifeng-groupbuy.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-groupbuy.vue?vue&type=style&index=0&id=2b5f346d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5f346d",
  null
  
)

export default component.exports